import { route } from 'preact-router';

interface Props {
  currentPath?: string;
}

export function Header({ currentPath = '/' }: Props) {
  return (
    <header style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '12px 20px',
      background: 'white',
      borderBottom: '1px solid var(--color-border)',
      position: 'sticky',
      top: 0,
      zIndex: 100,
    }}>
      <button
        onClick={() => route('/')}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          fontSize: '1.2rem',
          fontWeight: 'bold',
          fontFamily: 'var(--font-display)',
          color: 'var(--color-primary)',
          padding: '4px 8px',
        }}
      >
        🪭 うちメーカー
      </button>

      <nav style={{ display: 'flex', gap: '8px' }}>
        <NavLink href="/" label="ホーム" active={currentPath === '/'} />
        <NavLink href="/create" label="作成" active={currentPath === '/create'} />
      </nav>
    </header>
  );
}

function NavLink({ href, label, active }: { href: string; label: string; active: boolean }) {
  return (
    <button
      onClick={() => route(href)}
      style={{
        background: active ? 'var(--color-surface)' : 'none',
        border: 'none',
        borderRadius: '8px',
        padding: '6px 14px',
        cursor: 'pointer',
        fontSize: '0.9rem',
        fontWeight: active ? 'bold' : 'normal',
        color: active ? 'var(--color-primary)' : 'var(--color-text)',
      }}
    >
      {label}
    </button>
  );
}
